import { lazy } from "@loadable/component";
import { Suspense } from "react";
import { ErrorBoundary } from "@sentry/react";
import { ErrorFallback } from "../../patterns";

import { CustomFormSubmissionsLoading } from "./CustomFormSubmissions.loading";
import { CustomFormSubmissionsProps } from "./CustomFormSubmissions.types";

export const CustomFormSubmissionsLoadable = lazy(
  () => import("./CustomFormSubmissions")
);

export const CustomFormSubmissions = (props: CustomFormSubmissionsProps) => (
  <ErrorBoundary fallback={<ErrorFallback />}>
    <Suspense fallback={<CustomFormSubmissionsLoading />}>
      <CustomFormSubmissionsLoadable {...props} />
    </Suspense>
  </ErrorBoundary>
);
